import { AxiosResponse } from "axios";
import apiInstance from "../axios";
import { checkResponseStatus } from "./checkResponseStatus";

interface PostRequestOptions {
  route: string;
  payload?: any;
  queryParams?: any;
  pathVariables?: Record<string, string>;
  formData?: boolean;
}

export async function postRequest(
  options: PostRequestOptions
): Promise<AxiosResponse> {
  const { route, payload, queryParams, pathVariables } = options;

  try {
    let modifiedRoute = route;

    const config = {
      params: queryParams,
      headers: {},
    };

    if (pathVariables) {
      Object.entries(pathVariables).forEach(([key, value]) => {
        modifiedRoute = modifiedRoute.replace(`:${key}`, value);
      });
    }

    const response = await apiInstance.post(modifiedRoute, payload, config);

    checkResponseStatus(response.status);
    return response;
  } catch (error: any) {
    if (error.response) {
      checkResponseStatus(error.response.status);
      return error.response;
    }
    return error;
  }
}
